import React, { useEffect } from 'react';
import { useLocation } from '../../contexts/LocationContext';

const LocationTest: React.FC = () => {
  const {
    currentCity,
    currentCityData,
    isLoading,
    error,
    cities,
    detectByGeolocation,
    setCurrentCity,
    autoDetectEnabled,
    setAutoDetectEnabled,
    searchCities,
  } = useLocation();

  useEffect(() => {
    console.log('Location Test component mounted');
  }, []);

  const handleDetectLocation = async () => {
    try {
      const city = await detectByGeolocation();
      console.log('Detected city:', city);
    } catch (err) {
      console.error('Detection error:', err);
    }
  };

  const handleSetCity = async () => {
    try {
      await setCurrentCity('Київ');
      console.log('City set to Kyiv');
    } catch (err) {
      console.error('Set city error:', err);
    }
  };

  const handleSearch = async () => {
    try {
      const results = await searchCities('Льв');
      console.log('Search results:', results);
    } catch (err) {
      console.error('Search error:', err);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>🌍 Тест системи геолокації</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Поточний стан:</h3>
        <p><strong>Поточне місто:</strong> {currentCity || 'Не визначено'}</p>
        <p><strong>Завантаження:</strong> {isLoading ? 'Так' : 'Ні'}</p>
        <p><strong>Помилка:</strong> {error || 'Немає'}</p>
        <p><strong>Автовизначення:</strong> {autoDetectEnabled ? 'Увімкнено' : 'Вимкнено'}</p>
        
        {currentCityData && (
          <div>
            <h4>Дані поточного міста:</h4>
            <ul>
              <li>ID: {currentCityData.id}</li>
              <li>Назва (UA): {currentCityData.name_uk}</li>
              <li>Назва (EN): {currentCityData.name_en}</li>
              <li>Область: {currentCityData.region}</li>
              <li>Координати: {currentCityData.latitude}, {currentCityData.longitude}</li>
              <li>Популярне: {currentCityData.is_popular ? 'Так' : 'Ні'}</li>
            </ul>
          </div>
        )}

        {cities && (
          <div>
            <h4>Завантажені міста:</h4>
            <p>Популярні: {cities.popular.length}</p>
            <p>Всього: {cities.all.length}</p>
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button 
          onClick={handleDetectLocation}
          disabled={isLoading}
          style={{ padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}
        >
          📍 Визначити геолокацію
        </button>

        <button 
          onClick={handleSetCity}
          disabled={isLoading}
          style={{ padding: '10px 15px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '5px' }}
        >
          🏙️ Встановити Київ
        </button>

        <button 
          onClick={handleSearch}
          disabled={isLoading}
          style={{ padding: '10px 15px', backgroundColor: '#ffc107', color: 'black', border: 'none', borderRadius: '5px' }}
        >
          🔍 Пошук "Льв"
        </button>

        <button 
          onClick={() => setAutoDetectEnabled(!autoDetectEnabled)}
          style={{ padding: '10px 15px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '5px' }}
        >
          ⚙️ Перемикнути автовизначення
        </button>
      </div>

      <div style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
        <p>Відкрийте консоль браузера для перегляду логів роботи системи.</p>
      </div>
    </div>
  );
};

export default LocationTest;